export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const UPDATE_ALL_NOTIFICATIONS = 'UPDATE_ALL_NOTIFICATIONS';
export const UPDATE_SINGLE_NOTIFICATION = 'UPDATE_SINGLE_NOTIFICATION';
export const SET_SINGLE_NOTIFICATION = 'SET_SINGLE_NOTIFICATION';
